<div class="app-shell">
  <!-- SIDEBAR -->
  <nav class="sidebar">
    <div class="sidebar-logo">
      <div class="sidebar-logo-icon">AG</div>
      <div>
        <div class="sidebar-logo-name">AdGate</div>
        <div class="sidebar-logo-region">Latin America</div>
      </div>
    </div>

    <div class="sidebar-section">General</div>
    <div class="sidebar-item" [class.active]="this.moduleActivationService.getCurrentModule() === AdGateConstants.MODULE_DASHBOARD" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_DASHBOARD)">
      <i class="fa-solid fa-gauge-high"></i> Dashboard
    </div>

    <div class="sidebar-section">Modules</div>
    @if( showModule.linear) {
      <div class="sidebar-item" [class.active]="this.moduleActivationService.getCurrentModule() === AdGateConstants.MODULE_LINEAR" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_LINEAR)">
        <i class="fa-solid fa-tv"></i> TV / Radio
      </div>
    }
    @if( showModule.streaming) {
      <div class="sidebar-item" [class.active]="this.moduleActivationService.getCurrentModule() === AdGateConstants.MODULE_STREAMING" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_STREAMING)">
        <i class="fa-solid fa-mobile-screen"></i> Streaming / Digital
      </div>
    }
    @if( showModule.production) {
      <div class="sidebar-item" [class.active]="this.moduleActivationService.getCurrentModule() === AdGateConstants.MODULE_PRODUCTION" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_PRODUCTION)">
        <i class="fa-solid fa-film"></i> Production
      </div>
    }
    @if( showModule.admin) {
      <div class="sidebar-item" style="margin-top: 20px;" [class.active]="this.moduleActivationService.getCurrentModule() === AdGateConstants.MODULE_ADMINPANEL" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_ADMINPANEL)">
        <i class="fa-solid fa-screwdriver-wrench"></i> Admin Panel
      </div>
    }

    <div class="sidebar-bottom">
      <div class="notif-label">
        <i class="fa-solid fa-bell" style="margin-right:4px;font-size:9px"></i> Notifications ({{ notificationList.length }})
      </div>
      @if (notificationList.length === 0) {
        <div style="color: white; padding: 8px; font-size: 11px;">No notifications</div>
      }
      @for( n of notificationList; track n) {
        <div class="notif-item">
          <div class="notif-dot" [style.background-color]="decodeNotificationColor(n)"></div>
          {{n.message}}
        </div>
      }
    </div>
  </nav>

  <!-- MAIN CONTENT AREA -->
  <div class="main-area">
    <!-- TOPBAR -->
    <header class="topbar">
      @if( showTabs() ) {
        @for( tab of activeRouteComponent.getTabs(); track tab ) {
          <div class="topbar-tabs" (click)="onChangeTab(tab.tabNum)">
              <div class="topbar-tab" [class.active]="activeRouteComponent.getActiveTab() === tab.tabNum">{{ tab.tabDescription }}</div>
          </div>
        }
      }

      <div class="topbar-spacer"></div>

      <div class="topbar-right">
        @if( showQuickSearch() ) {
            <mat-form-field appearance="outline" class="search-box">
              <i class="fa-solid fa-search" matPrefix></i>
              <input matInput #searchBox [placeholder]="getQuickSearchPlaceholder()" (keyup)="onQuickSearch($event.target)">
            </mat-form-field>
        }

        @if( showFilter()) {
          <button matButton class="icon-btn" matTooltip="Filters" (click)="onFilter()">
            <i class="fa-solid fa-sliders"></i>
          </button>
        }

        @if( showExport() ) {
          <button matButton class="export-btn" matTooltip="Export List" (click)="onExport()">
            <i class="fa-solid fa-file-export"></i>
              Export
          </button>
        }

        <button matButton class="icon-btn" matTooltip="Refresh" (click)="onRefresh()">
          <i class="fa-solid fa-rotate-right"></i>
        </button>
        <button id='helpcenter' class="icon-btn" matTooltip="Help Center" (click)="onOpenHelpCenter()" style="color:#1E40AF">
          <i class="fa-regular fa-circle-question"></i>
        </button>
        <div class="user-info" style="cursor:pointer" (click)="onShowUserProfile()">
          <div class="user-avatar">{{ stateService.getUserInitials() }}</div>
          <span class="user-name">{{ stateService.getUserName() }}</span>
        </div>
        <button class="icon-btn chatbot-btn" matTooltip="Adgate Assistant" (click)="onOpenAssistant()">
          <i class="fa-solid fa-robot"></i>
        </button>
        <button class="icon-btn" matTooltip="Sign out" style="color:#991B1B" (click)="onSignOut()">
          <i class="fa-solid fa-right-from-bracket"></i>
        </button>
      </div>
    </header>

    <!-- PAGE CONTENT -->
    <main class="page-content">
      <router-outlet (activate)="onActivateRoute($event)" />
    </main>
  </div>
</div>
